import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SOCIALS } from "@/components/site/SocialLinks";
import { faq } from "@/lib/ambassadors";
import { A, Eyebrow, Reveal } from "./ui";

const TODO = /(\[À COMPLÉTER[^\]]*\])/;
const Text = ({ t }) => t.split(TODO).map((part, i) => (TODO.test(part)
  ? <mark key={i} data-testid="amb-todo" className="rounded-sm bg-amber-200 px-1 text-[#141013]">{part}</mark> : part));

export function AmbFaq({ program }) {
  const items = faq(program);
  return (
    <section id="faq" data-testid="amb-faq" className={`${A.ivory} scroll-mt-24 px-5 py-20 md:px-10 md:py-28`}>
      <div className="mx-auto max-w-3xl">
        <Reveal><Eyebrow>Questions fréquentes</Eyebrow><h2 className={`font-display text-3xl md:text-4xl ${A.ink}`}>FAQ du programme</h2></Reveal>
        <Accordion type="single" collapsible className="mt-10">
          {items.map((it, i) => (
            <AccordionItem key={it.q} value={`q${i}`} className="border-b border-[#E3D5C3]">
              <AccordionTrigger data-testid={`amb-faq-q-${i}`} className={`py-5 text-left font-display text-lg hover:no-underline ${A.ink}`}>{it.q}</AccordionTrigger>
              <AccordionContent data-testid={`amb-faq-a-${i}`} className={`pb-5 text-base leading-relaxed ${A.muted}`}><Text t={it.a} /></AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}

export function AmbConditions({ program }) {
  return (
    <section id="conditions" data-testid="amb-conditions" className={`${A.bg} scroll-mt-24 px-5 pb-20 md:px-10`}>
      <div className={`mx-auto max-w-3xl rounded-2xl border ${A.border} bg-white p-7`}>
        <h2 className={`font-display text-2xl ${A.ink}`}>Conditions du programme</h2>
        {program.conditions.split("\n").filter(Boolean).map((p) => <p key={p} className={`mt-4 whitespace-pre-line text-sm leading-relaxed ${A.muted}`}><Text t={p} /></p>)}
        <p className={`mt-4 text-sm ${A.muted}`}>Ozentya se réserve le droit de sélectionner les ambassadeurs. Les publications réalisées dans le cadre du programme doivent signaler clairement le partenariat avec Ozentya (par exemple avec la mention « Collaboration commerciale » ou « Partenariat »), conformément à la loi n° 2023-451 du 9 juin 2023 encadrant l'influence commerciale.</p>
      </div>
    </section>
  );
}

export function AmbFinal() {
  return (
    <section data-testid="amb-final" className="bg-[#141013] px-5 py-24 text-center md:px-10 md:py-32">
      <Reveal>
        <h2 className="font-display text-4xl text-[#FBF8F3] sm:text-5xl">Ton univers. Ta communauté. <span className="italic text-[#E5C88F]">Ozentya.</span></h2>
        <p className="mx-auto mt-6 max-w-xl text-base text-[#E9DFD2] md:text-lg">Rejoins une communauté qui partage, inspire et fait découvrir Ozentya chaque jour.</p>
        <a href="#candidature" data-testid="amb-final-cta" className="mt-10 inline-flex h-14 items-center rounded-full bg-[#E5C88F] px-10 text-xs font-semibold uppercase tracking-[0.2em] text-[#141013] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#F1DBA6]">Je candidate maintenant</a>
      </Reveal>
      <nav aria-label="Liens du programme" data-testid="amb-footer-links" className="mx-auto mt-16 flex max-w-3xl flex-wrap justify-center gap-x-6 gap-y-3 border-t border-[#E5C88F]/30 pt-8 text-sm text-[#E9DFD2]">
        <Link to="/" className="hover:text-[#F1DBA6]">Site officiel Ozentya</Link>
        <a href={SOCIALS.instagramParis} target="_blank" rel="noopener noreferrer" className="hover:text-[#F1DBA6]">Instagram</a>
        <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" className="hover:text-[#F1DBA6]">TikTok</a>
        <Link to="/mentions-legales" className="hover:text-[#F1DBA6]">Mentions légales</Link>
        <Link to="/confidentialite" className="hover:text-[#F1DBA6]">Confidentialité</Link>
        <a href="#conditions" className="hover:text-[#F1DBA6]">Conditions du programme</a>
        <Link to="/espace-ambassadeur" data-testid="amb-footer-space" className="hover:text-[#F1DBA6]">Espace ambassadeur (connexion)</Link>
      </nav>
    </section>
  );
}
